/**
 * Il marchio, in SVG inline.
 *
 * È la stessa geometria di `public/favicon.svg` — anello blu/oro spezzato ai
 * poli e curva in salita — cioè il marchio *ridotto*, non il logo completo:
 * alle misure a cui l'interfaccia lo usa (20–40px) cervello, nodi e candele si
 * impastano. Inline e non `<img>` perché così scala senza sfocare e non
 * aggiunge una richiesta di rete al primo dipinto.
 *
 * I colori sono quelli del logo, quindi restano identici nei due temi: qui non
 * si passa dai token di superficie (`docs/BRAND.md`).
 */

type LogoProps = {
  /** Lato in pixel. L'SVG è quadrato. */
  size?: number;
  className?: string;
  /**
   * Testo alternativo. Omesso, il marchio è decorativo — il caso normale,
   * perché accanto c'è già il nome scritto.
   */
  title?: string;
};

export function Logo({ size = 24, className, title }: LogoProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      {title && <title>{title}</title>}
      <circle cx="32" cy="32" r="20" fill="var(--brand-mint)" />
      <g fill="none" strokeWidth="8" strokeLinecap="round">
        <path d="M 30.19 57.94 A 26 26 0 0 1 30.19 6.06" stroke="var(--brand-blue)" />
        <path d="M 33.81 6.06 A 26 26 0 0 1 33.81 57.94" stroke="var(--brand-gold-deep)" />
      </g>
      <path
        d="M 17.5 40.5 L 26 35.5 L 32.5 38 L 41 25.5"
        fill="none"
        stroke="var(--brand-orange)"
        strokeWidth="4.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M 45.5 20.5 L 36 22.5 L 42.5 30.5 Z" fill="var(--brand-orange)" />
    </svg>
  );
}
